import React, { useEffect, useState } from "react";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  CardBody,
  Spinner,
} from "reactstrap";
import { getOfferById } from "service/offer.service";
import Step1Form from "./steps/Step1Form";
import Step2Form from "./steps/Step2Form";
import Step3Form from "./steps/Step3Form";
import Step4Form from "./steps/Step4Form";
import Step5Form from "./steps/Step5Form";
import Step6Form from "./steps/Step6Form";
import { useParams } from "react-router-dom";

const AnimatedNavItem = ({ currentStep, stepNumber, label, onClick }) => {
  const isActive = currentStep === stepNumber;
  const customPadding = isActive ? "active custom-padding " : "custom-padding";

  return (
    <NavItem className="pt-2 pl-2 b">
      <NavLink
        className={`btn btn-outline-secondary btn-sm  ${customPadding}`}
        style={{ padding: "0.5rem 2rem" }}
        onClick={onClick}
      >
        {label}{" "}
      </NavLink>{" "}
    </NavItem>
  );
};

const MultiStepForm = () => {
  const [step, setStep] = useState(1);
  const [currentStep, setCurrentStep] = useState(1);
  const [isPreloading, setIsPreLoaded] = useState(true);
  const [formData, setFormData] = useState({
    id: 0,
    offer_name: "",
    offer_short_description: "",
    offer_long_description: "",
    offer_package_name: "",
    advertiser: "",
    offer_small_icon: "",
    offer_medium_icon: "",
    offer_large_icon: "",
    offer_banner_image: "",
    is_promotional: false,
    offer_revenue: 0,
    offer_payout: 0,
    offer_user_reward: 0,
    offer_type: "",
    offer_app_preview_required: false,
    offer_app_title: "",
    offer_app_description: "",
    offer_video_link: "",
    division_rule: "",
    offer_tags: [],
    offer_badges: [],
    user_conversion_count: 0,
    is_special_offer: false,
    is_video_available: false,
    is_promotional: false,
  });
  const { id } = useParams();
  useEffect(() => {
    fetchOfferById(id);
  }, [id]);

  const fetchOfferById = async (id) => {
    try {
      console.log(id);
      const data = await getOfferById(id);
      console.log(data);
      setFormData(data.data.result);
      setIsPreLoaded(false);
    } catch (error) {
      console.error("Error fetching offers:", error);
    }
  };

  const handleStepClick = (step) => {
    setCurrentStep(step);
  };
  const handleNextStep = () => {
    setStep(step + 1);
  };

  const handlePreviousStep = () => {
    setStep(step - 1);
  };

  const handleChange = (data) => {
    setFormData({ ...formData, ...data });
    console.log(data);

    console.log(formData);
  };

  const renderFormStep = () => {
    switch (step) {
      case 1:
        return (
          <Step1Form
            formData={formData}
            handleChange={handleChange}
            handleNextStep={handleNextStep}
          />
        );
      case 2:
        return (
          <Step2Form
            formData={formData}
            handleChange={handleChange}
            handleNextStep={handleNextStep}
            handlePreviousStep={handlePreviousStep}
          />
        );
      case 3:
        return (
          <Step3Form
            formData={formData}
            handleChange={handleChange}
            handleNextStep={handleNextStep}
            handlePreviousStep={handlePreviousStep}
          />
        );
      case 4:
        return (
          <Step4Form
            formData={formData}
            handleChange={handleChange}
            handleNextStep={handleNextStep}
            handlePreviousStep={handlePreviousStep}
          />
        );
      case 5:
        return (
          <Step5Form
            formData={formData}
            handleChange={handleChange}
            handleNextStep={handleNextStep}
            handlePreviousStep={handlePreviousStep}
          />
        );
      case 6:
        return (
          <Step6Form
            formData={formData}
            handleChange={handleChange}
            handleNextStep={handleNextStep}
            handlePreviousStep={handlePreviousStep}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center">
      {" "}
      {isPreloading ? (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ background: "rgba(0, 0, 0, 0.5)", zIndex: 9999 }}
        >
          <Spinner type="grow" color="primary" />
        </div>
      ) : (
        <div className="container mt-4">
          <div className="card shadow">
            <div className="">
              {/* Sidebar */}{" "}
              <div className="col-lg-12">
                <Nav pills>
                  <AnimatedNavItem
                    currentStep={step}
                    stepNumber={1}
                    label="Basic"
                    onClick={() => setStep(1)}
                  />{" "}
                  <AnimatedNavItem
                    currentStep={step}
                    stepNumber={2}
                    label="Tracking Panel"
                    onClick={() => setStep(2)}
                  />{" "}
                  <AnimatedNavItem
                    currentStep={step}
                    stepNumber={5}
                    label="Targetting"
                    onClick={() => setStep(5)}
                  />{" "}
                  <AnimatedNavItem
                    currentStep={step}
                    stepNumber={3}
                    label="App Description"
                    onClick={() => setStep(3)}
                  />{" "}
                  <AnimatedNavItem
                    currentStep={step}
                    stepNumber={4}
                    label="Event"
                    onClick={() => setStep(4)}
                  />
                  {/* <AnimatedNavItem
                            currentStep={step}
                            stepNumber={6}
                            label="Scheduling"
                            onClick={() => setStep(6)}
                          />  */}{" "}
                  <NavItem className="pt-2 pr-2 ml-auto">
                    <Button color="success" size="sm">
                      View Preview{" "}
                    </Button>{" "}
                  </NavItem>{" "}
                </Nav>
              </div>{" "}
              <div className="card-header bg-transparent">
                <div className="container">
                  {/* Form */}{" "}
                  <div className="col-lg-12"> {renderFormStep()} </div>{" "}
                </div>{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </div>
      )}{" "}
    </div>
  );
};

export default MultiStepForm;
